export enum MakerSubscriptionStatus {
        // The subscription initial payment attempt failed.
        Incomplete,
        // The subscription initial payment attempt failed and was not corrected within 23 hours.
        // Essentially canceled due to no payment.
        IncompleteExpired,
        // The subscription is in trial.
        Trial,
        // The subscription is active and user should have full benefits.
        // When canceling at end of term, subscription is still considered active.
        Active,
        // The subscription payment to renew failed. 
        PastDue,
        // The subscription is canceled.
        Canceled,
        // The subscription is unpaid.
        Unpaid
}

export default interface MakerSubscription {
    id: string;
    accountId: string;
    status: MakerSubscriptionStatus;
    serviceStopDate?: string;
    serviceStartDate?: string;
    cancellationDate?: string;
    currentPlanName: "Annual" | "Annual - Discount" | "Monthly" | "Standard" | "Standard - Discount";
}

export function isActiveMakerSubscription(subscription?:MakerSubscription){
    if(!subscription){
        return false
    };
    switch(subscription.status){
        case MakerSubscriptionStatus.Active:
        case MakerSubscriptionStatus.Trial:
            return true;
        default:
            return false;
    }
}